import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { ItemCategory, ItemCategoryResponse } from '../interfaces/item-category.interface';
import {AuthService} from "./auth.service";

export const ItemCategoryService = {
    getItemCategoriesByInstitution: async (page: number = 0, size: number = 10): Promise<ItemCategoryResponse> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.ITEM_CATEGORY.LIST_BY_INSTITUTION}/${institutionId}?page=${page}&size=${size}`);
        return response.data;
    },

    createItemCategory: async (itemCategory: ItemCategory): Promise<void> => {
        await axios.post(ENDPOINTS.ITEM_CATEGORY.BASE, itemCategory);
    },

    updateItemCategory: async (id: string, itemCategory: ItemCategory): Promise<void> => {
        await axios.put(ENDPOINTS.ITEM_CATEGORY.UPDATE(id), itemCategory);
    },

    deleteItemCategory: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.ITEM_CATEGORY.DELETE(id));
    }
};
